import React, { useState } from "react";
import {
  Menu,
  MenuItem,
  IconButton,
  Fade,
  ListItemIcon,
  ListItemText,
  Divider,
  Tooltip,
  Typography,
  Box
} from "@mui/material";
import {
  PlayCircleOutline,
  Dashboard,
  Forum,
  // History,
  // VideoLibrary,
  // EventNote,
  // Assignment,
  // Circle,
  // PlayCircle,
  EmojiEvents,
  School,
  HelpOutline,
  MenuBook,
  CreditCard,
  AttachMoney,
  Email,
  LockOutlined,
  Stars,
  RocketLaunch,
  WorkspacePremium 
} from "@mui/icons-material";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../hooks/AuthContext";

const MainMenu = () => {
  const { t } = useTranslation("mainmenu");
  const navigate = useNavigate();
  const { isAuthenticated, user } = useAuth();

  const isEarlyPitcher = !!user?.is_early_pitcher; // ajustá al nombre real del campo
  const isUndeltaUser = user?.source === "undelta";

  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const handleOpen = (event) => setAnchorEl(event.currentTarget);
  const handleClose = () => setAnchorEl(null);
  const handleNavigate = (path) => {
    navigate(path);
    handleClose();
  };

  const menuItems = [
    {
      label: t("new_session"),
      path: "/pitch-start",
      icon: <PlayCircleOutline fontSize="small" />
    },
    {
      label: t("activity"),
      path: "/dashboard",
      icon: <Dashboard fontSize="small" />,
      protected: true
    },
    {
      label: t("sessions"),
      path: "/sessions",
      icon: <Forum fontSize="small" />,
      protected: true
    },
    {
      label: t("achievements"),
      path: "/achievements",
      icon: <EmojiEvents fontSize="small" />,
      protected: true
    },
    // {
    //   label: t("tutorial"),
    //   path: "/how-it-works",
    //   icon: <School fontSize="small" />
    // },
    {
      label: t("faqs"),
      path: "/faqs",
      icon: <HelpOutline fontSize="small" />
    },
    // {
    //   label: t("academy"),
    //   path: "/academy",
    //   icon: <MenuBook fontSize="small" />,
    //   disabled: true
    // },
    {
      label: t("early_pitcher"),
      path: "/early-pitchers",
      icon: <WorkspacePremium fontSize="small" />,
      // protected: true,
      hideIfEarlyPitcher: true, 
    },
    {
      label: t("account"),
      path: "/billing",
      icon: <CreditCard fontSize="small" />,
      protected: true,
      earlyOnly: true
    },
    {
      label: t("pricing"),
      path: "/pricing",
      icon: <AttachMoney fontSize="small" />,
      protected: true,
      earlyOnly: true
    },
    {
      label: t("contact"),
      path: "/contact",
      icon: <Email fontSize="small" />
    }
  ];

  const canSeeItem = (item) =>
    (!item.protected || isAuthenticated) &&
    (!item.earlyOnly || isEarlyPitcher || isUndeltaUser) &&
    (!item.hideIfEarlyPitcher || (!isEarlyPitcher && !isUndeltaUser));

  const group1 = menuItems.slice(0, 4).filter(canSeeItem);
  const group2 = menuItems.slice(4, 5).filter(canSeeItem);
  const group3 = menuItems.slice(5, 8).filter(canSeeItem);
  const group4 = menuItems.slice(8).filter(canSeeItem);

  const renderItems = (items) =>
    items.map((item) => {
      const isAcademy = item.disabled && item.label === t("academy");

      if (item.disabled && isAcademy ) {
return (
  <MenuItem
    key={item.path}
    disabled
    sx={{ opacity: 0.95, display: "flex", flexDirection: "column", alignItems: "flex-start" }}
  >
    <Box sx={{ display: "flex", alignItems: "center", width: "100%" }}>
      <ListItemIcon sx={{ color: "#fff" }}>
        <LockOutlined fontSize="small" />
      </ListItemIcon>
      <ListItemText primary={item.label} />
    </Box>
    <Typography
      variant="caption"
      sx={{ fontSize: "0.7rem", color: "#ffffff", ml: 4 }}
    >
      ({t("coming_soon")})
    </Typography>
  </MenuItem>
);

      }

      return (
        <MenuItem
          key={item.path}
          onClick={() => handleNavigate(item.path)}
          sx={{
            "&:hover": {
              backgroundColor: "rgba(255, 255, 255, 0.1)"
            }
          }}
        >
          <ListItemIcon sx={{ color: "#fff" }}>{item.icon}</ListItemIcon>
          <ListItemText primary={item.label} />
        </MenuItem>
      );
    });

  // Solo uso los grupos que tengan items
  const groups = [group1, group2, group3, group4].filter(
    (g) => g && g.length > 0
  );

  return (
    <>
      <IconButton onClick={handleOpen} color="inherit" sx={{ p: 0 }}>
        <img src="/assets/logo-icon.png" alt="Logo" style={{ height: 28 }} />
      </IconButton>

      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        TransitionComponent={Fade}
        PaperProps={{
          sx: {
            bgcolor: "rgba(0,0,0,0.7)",
            color: "#fff",
            borderRadius: 2,
            backdropFilter: "blur(6px)",
            mt: 1,
            p: 0.5
          }
        }}
      >
        {groups.flatMap((group, index) => [
          ...renderItems(group),
          ...(index < groups.length - 1
            ? [
                <Divider
                  key={`divider-${index}`}
                  sx={{ my: 1, borderColor: "rgba(255,255,255,0.1)" }}
                />
              ]
            : [])
        ])}
      </Menu>
    </>
  );
};

export default MainMenu;
